<div class="dialog">
  <div class="dialog-header">
    <div class="title">Send Invites</div>
    <button mat-icon-button type="button" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="automation-state">{{ automationSummary }}</div>

  <mat-radio-group class="mode-group" [(ngModel)]="mode">
    <mat-radio-button value="now">Send now</mat-radio-button>
    <mat-radio-button value="scheduled">Send on date</mat-radio-button>
  </mat-radio-group>

  @if (mode === 'scheduled') {
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Send date</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        [min]="minDate"
        [max]="maxDate"
        [(ngModel)]="scheduledDate"
        />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  }

  <div class="actions">
    @if (automation?.enabled) {
      <button
        mat-stroked-button
        type="button"
        color="warn"
        [disabled]="isSubmitting"
        (click)="disableAutomation()"
        >
        Disable Automation
      </button>
    }
    <span class="spacer"></span>
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSubmit" (click)="submit()">
      {{ mode === 'now' ? 'Send Now' : 'Schedule' }}
    </button>
  </div>
</div>
